import React from 'react'
import {
  CardOnFileContainer,
  CardOnFileBox,
  CardOnFileCVCInput,
  CardOnFileDescription,
  CardOnFileLabel,
  CardOnFilePrimaryButton,
  CardOnFileSecondaryButton,
} from '../../card-on-file.styled'
import {useBillingInfo} from './contexts/billing-info-context'
import {toast} from 'react-toastify'
import {usePaymentCheckboxes} from './contexts/payment-checkboxes-context'
import {useRecurlyPayment} from './contexts/recurly-payment-context'
import {SavedBlankCard} from '../../../assets/saved-blank-card'
import {CardValidIcon} from '../../../assets/CardValidIcon'
import {useSelector} from 'react-redux'

export function CardOnFileForm({setPaymentRequestState, disclaimerText}) {
  const isMobile = useSelector(state => state.screenView.isMobileViewEnable)
  const {
    billingInfo,
    verifyCVC,
    isCVCVerified,
    setIsCVCVerified,
    isVerifying,
    setTryCardOnFile,
    cvc,
    setCVC,
  } = useBillingInfo()
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  return (
    <CardOnFileContainer>
      <div className="section-heading">
        <div className="section-heading-title-container">
          <p className="section-heading-title">Enter Card Details</p>
          <p className="section-heading-subtitle">
            Provide card details to proceed with payment
          </p>
        </div>
        <CardOnFilePrimaryButton
          disabled={isVerifying || checkBoxesValues.agreedTerms}
          type="button"
          onClick={() => {
            setTryCardOnFile(false)
            setPaymentRequestState({
              hasErrors: false,
              requested: false,
              merchantMessage: null,
            })
            setCheckBoxesValues({
              ...checkBoxesValues,
              agreedTerms: false,
            })
            setIsCVCVerified(false)
          }}
        >
          Use Different Payment
        </CardOnFilePrimaryButton>
      </div>

      <section style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
        <SavedBlankCard
          width={isMobile ? 290 : 350}
          cardBrand={billingInfo.paymentMethod.cardType}
          lastFour={billingInfo.paymentMethod.lastFour}
          cardholderName={`${billingInfo.firstName} ${billingInfo.lastName}`}
          expiryDate={`${billingInfo.paymentMethod.expMonth
            .toString()
            .padStart(2, '0')}/${billingInfo.paymentMethod.expYear
            .toString()
            .slice(2)}`}
        />
        <CardOnFileBox isMobile={isMobile}>
          <CardOnFileDescription>
            Enter the <span style={{fontWeight: 700}}>3–4 digit code</span> on
            your card to proceed with payment
          </CardOnFileDescription>
          <div style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
            <CardOnFileLabel>CVV / CVC Number</CardOnFileLabel>
            <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
              <CardOnFileCVCInput
                style={{flex: 1, minWidth: 0}}
                placeholder="3 or 4 digits"
                data-dd-privacy="mask"
                type="text"
                name="cvc"
                maxLength={4}
                disabled={checkBoxesValues.agreedTerms}
                onChange={e => {
                  setCVC(e.target.value)
                  setCheckBoxesValues({
                    ...checkBoxesValues,
                    agreedTerms: false,
                  })
                }}
                value={cvc}
              />
              {isCVCVerified && <CardValidIcon />}
            </div>
          </div>
          <CardOnFilePrimaryButton
            disabled={
              isVerifying ||
              isCVCVerified ||
              checkBoxesValues.agreedTerms ||
              cvc.length < 3
            }
            className={`${
              isVerifying ||
              isCVCVerified ||
              checkBoxesValues.agreedTerms ||
              cvc.length < 3
                ? 'disable-with-opacity'
                : ''
            }`}
            type="button"
            onClick={async e => {
              e.preventDefault()
              const {valid, message} = await verifyCVC(cvc)
              if (!valid) {
                toast.error(message)
                return undefined
              }
              toast.success(message)
            }}
          >
            Confirm
          </CardOnFilePrimaryButton>
        </CardOnFileBox>
      </section>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          marginTop: '12px',
        }}
      >
        {disclaimerText && (
          <p className="card-number-helper-text" style={{margin: 0}}>
            {disclaimerText}
          </p>
        )}
        <p className="card-number-helper-text" style={{margin: 0}}>
          {
            "By processing your payment, you agree that your personal information will be shared with Thryv's payment processor—Adyen, N.V. and will be subject to Adyen's "
          }
          <a
            target="_blank"
            href="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
            rel="noreferrer"
            style={{fontWeight: 700, color: '#5378FC'}}
          >
            privacy statement
          </a>
          {'.'}
        </p>
      </div>
    </CardOnFileContainer>
  )
}

export function ChangeToCardOnFileButton() {
  const {billingInfo, setTryCardOnFile} = useBillingInfo()
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  const {clearRecurlyToken} = useRecurlyPayment()
  if (!billingInfo) return undefined

  return (
    <CardOnFileSecondaryButton
      type="button"
      disabled={checkBoxesValues.agreedTerms}
      onClick={() => {
        setTryCardOnFile(true)
        clearRecurlyToken()
        setCheckBoxesValues({
          ...checkBoxesValues,
          agreedTerms: false,
        })
      }}
    >
      Use card on file
    </CardOnFileSecondaryButton>
  )
}
